angular.module("digitalLeasing.module").component("customerSelection", {
  templateUrl: "ng/components/digitalLeasing/customerSelection/customerSelection.view.html",
  bindings: {
    model: "=",
    vendor: "=",
    validatePage: "&",
    invalidatePage: "&",
    callNextStep: '&',
    digital: "<",
    isAnagSearch: "<?"
  },
  controllerAs: "CustomerSelectionCtrl",
  controller: CustomerSelectionController
});

function CustomerSelectionController(
  $scope,
  FinancialCustomer,
  $financialApiService,
  $filter,
  validationService
) {

  var self = this;

  self.$onInit = function () {
    self.enableErrorCF = true;
    self.supportModel = {
      customer: {
        piva: null,
        ragSoc: null,
        cf: null,
        ndg: "",
        identifierType: null,
        identifier: "",
        customerList: [],
      },
      previousCustomer: {
        identifier: null,
        ragSoc: null,
        cf: null,
        ndg: "",
        metadata: {
          riUserG: {
            sedeLegale: {
              comune: null,
              provincia: null
            }
          }
        }
      },
      loading: false,
      showNewCustomerForm: false,
      selectedCustomerUser: null,
      showResultTable: false,
      prefix: null
    };
    self.initialCfPiva = "";
    callCurrentDetail();
    if (self.model && self.model.metadata && self.model.metadata.riUserG && (self.model.metadata.riUserG.ndg != null || self.model.metadata.riUserG.piva != null || self.model.metadata.riUserG.ragioneSociale != null || self.model.metadata.riUserG.cf != null)) {
      self.model.selected = true;
      self.supportModel.previousCustomer.identifier = self.model.metadata.riUserG.piva;
      self.supportModel.previousCustomer.ndg = self.model.metadata.riUserG.ndg;
      self.supportModel.previousCustomer.ragSoc = self.model.metadata.riUserG.ragioneSociale;
      self.supportModel.previousCustomer.metadata.riUserG.sedeLegale.comune = self.model.metadata.riUserG.sedeLegale.comune;
      self.supportModel.previousCustomer.metadata.riUserG.sedeLegale.provincia = self.model.metadata.riUserG.sedeLegale.provincia;
      self.supportModel.customer.customerList = [self.supportModel.previousCustomer];
      self.supportModel.customer.cf = self.model.metadata.riUserG.cf;
    }
  };

  self.oneSelected = function () {
    return (
      self.supportModel.customer.piva ||
      self.supportModel.customer.ragSoc ||
      self.supportModel.customer.cf ||
      self.supportModel.customer.ndg
    );
  };

  self.getCustomer = function () {

    self.model = null;

    var customer = FinancialCustomer.build({
      cf: self.supportModel.customer.cf,
      ragSoc: self.supportModel.customer.ragSoc,
      ndg: self.supportModel.customer.ndg,
      piva: self.supportModel.customer.piva
    });

    self.supportModel.loading = true;
    self.supportModel.showResultTable = false;
    customer.metadata = null;
    $financialApiService
      .getCustomerByFilter(customer)
      .then(function (listAppCustomer) {

        self.supportModel.customer.customerList = listAppCustomer.listAppCustomer;

        if (self.supportModel.customer.customerList.length == 0) {
          if (self.isAnagSearch) {
            return;
          }
          self.model = FinancialCustomer.build();
          var initCfPiva =
            self.supportModel.customer.piva || self.supportModel.customer.cf;

          self.identifierType = self.supportModel.customer.cf ?
            $filter("translate")("CUSTOMER_SELECTION_CF") :
            $filter("translate")("CUSTOMER_SELECTION_PIVA");

          if (initCfPiva) {
            self.initialCfPiva = initCfPiva;
          }

          self.supportModel.showNewCustomerForm = true;

          //self.showNewCustomerForm({ showNewCustomerForm : self.supportModel.showNewCustomerForm})

        } else if (self.supportModel.customer.customerList.length == 1) {
          self.initialCfPiva = self.supportModel.customer.customerList[0].identifier
        }

      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        self.supportModel.loading = false;
      });
  };

  self.setCustomer = function (customer) {
    self.model = customer;
    if (self.model.isOk(false, false, false, false, false, false, false, true)) {
      self.validatePage();
    } else {
      self.invalidatePage();
    }
  };

  self.onNewClientBack = function () {

    self.supportModel.showNewCustomerForm = false;

    if (self.digital) {
      self.model.identifier = null;
      self.model.metadata.riUserG.cf = null;
      self.invalidatePage()
    } else {
      self.initialCfPiva = "";
    }

  };

  var callCurrentDetail = function () {
    if (self.vendor && !self.vendor.reteVendita) {
      $financialApiService
        .getCurrentDetail()
        .then(function (vendorResponse) {
          if (vendorResponse) {
            self.vendor = vendorResponse;
            console.log("FinancialVendor: ", self.vendor)
          }
        })
    }
  }

  self.changeInputValue = function (property, value) {
    if (property) {
      if (property == 'cf' && value && value.length == 16 && isNaN(value)) {
        value = value.toUpperCase();
        self.enableErrorCF = validationService.validateCf(value);
      } else {
        self.enableErrorCF = true;
      }
      self.supportModel.customer[property] = value;
      self.initialCfPiva = self.supportModel.customer.piva;
    }
  }

  self.customerIsOk = function () {
    self.validatePage();
  }

  self.customerIsNotOk = function () {
    self.invalidatePage();
  }

  self.callFunctionForNextStep = function () {
    self.callNextStep();
  }

}